import { gql, TypedDocumentNode } from "@apollo/client";

import {
  DeleteCompanionSessionMutation,
  DeleteCompanionSessionMutationVariables,
} from "./DeleteCompanionSession.generated";

export const DELETE_COMPANION_SESSION: TypedDocumentNode<
  DeleteCompanionSessionMutation,
  DeleteCompanionSessionMutationVariables
> = gql`
  mutation deleteCompanionSession($companionSessionUuid: String!) {
    deleteCompanionSession(
      companionSessionUuid: $companionSessionUuid
    ) {
      ok
    }
  }
`;
